import { ExpressionConfiguration } from "../rule-engine-core/Expressions/ExpressionConfiguration";
import { UIStandardLayer } from "../CommonUI/BuildlingBlocks/UIStandardLayer";
import { Box } from "@mui/material";
import { ExpressionBuilder } from "./ExpressionBuilder";
import React from "react";
import { ExpressionValueType } from "../rule-engine-core/Expressions/ExpressionValueType";

export function ExpressionEditLayer(props: {
    open: boolean;
    expression: ExpressionConfiguration;
    onClose: (updatedExpression: ExpressionConfiguration) => void;
    showClear?: boolean;
    clearName?: string;
}) {
    return (
        <UIStandardLayer
            data-testid={`expression_edit_layer_${props.expression._id}`}
            open={props.open}
            title={"Edit Expression"}
            primaryActionText={"Done"}
            onPrimaryAction={() => props.onClose(props.expression)}
            secondaryActionText={
                props.showClear && props.expression.valueType !== ExpressionValueType.UNSET
                    ? props.clearName ?? "clear"
                    : undefined
            }
            onSecondaryAction={
                props.showClear && props.expression.valueType !== ExpressionValueType.UNSET
                    ? () => {
                          props.expression.valueType = ExpressionValueType.UNSET;
                          props.onClose(props.expression);
                      }
                    : undefined
            }
            renderUI={() => (
                <Box
                    minWidth={"800px"}
                    minHeight={"500px"}
                >
                    <ExpressionBuilder expression={props.expression} />
                </Box>
            )}
            onClose={() => props.onClose(props.expression)}
        />
    );
}
